import { useState, useEffect, useCallback } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import trustpilot from '../assets/logo/Trust-Pilot.svg';
import ChannelCarousel from './channel'
import WcIntroOverlay from '../components/WcIntroOverlay';
import WorldCupBanner from '../components/WorldCupBanner';
import { useNavigate } from 'react-router-dom';

import tv from '../assets/tv.png'

import img1 from '../assets/poster/1.webp'
import img2 from '../assets/poster/2.webp'
import img3 from '../assets/poster/3.webp'
import img4 from '../assets/poster/4.webp'
import img5 from '../assets/poster/5.webp'
import img6 from '../assets/poster/6.webp'
import img7 from '../assets/poster/7.webp'
import img8 from '../assets/poster/8.webp'
import img9 from '../assets/poster/9.webp'
import img10 from '../assets/poster/10.webp'
import img11 from '../assets/poster/11.webp'
import img12 from '../assets/poster/12.webp'
import img13 from '../assets/poster/13.webp'
import img14 from '../assets/poster/14.webp'
import img15 from '../assets/poster/15.webp'
import img16 from '../assets/poster/16.webp'
import img17 from '../assets/poster/17.webp'
import img18 from '../assets/poster/18.webp'
import img19 from '../assets/poster/19.webp'
import img20 from '../assets/poster/20.webp'
import img21 from '../assets/poster/21.webp'
import img22 from '../assets/poster/22.webp'
import img23 from '../assets/poster/23.webp'
import img24 from '../assets/poster/24.webp'
import img25 from '../assets/poster/25.webp'
import img26 from '../assets/poster/26.webp'
import img27 from '../assets/poster/27.webp'
import img28 from '../assets/poster/28.webp'

export default function Home() {
    // Données des films avec informations
    const movies = [
        { id: 1, image: img1, title: "El Eternauta", category: "Sci-Fi" },
        { id: 2, image: img2, title: "Man vs Baby", category: "Comedia" },
        { id: 3, image: img3, title: "Friends", category: "Comedia" },
        { id: 4, image: img4, title: "El Grinch", category: "Animación" },
        { id: 5, image: img5, title: "Vikings", category: "Acción" },
        { id: 6, image: img6, title: "Better Call Saul", category: "Drama" },
        { id: 7, image: img7, title: "City of Shadows", category: "Acción" },
        { id: 8, image: img8, title: "Paw Patrol", category: "Animación" },
        { id: 9, image: img9, title: "Jurassic World: El Renacer", category: "Acción" },
        { id: 10, image: img10, title: "Avatar: Fuego y Ceniza", category: "Acción" },
        { id: 11, image: img11, title: "Dahmer", category: "Crimen" },
        { id: 12, image: img12, title: "Del Revés 2", category: "Animación" },
        { id: 13, image: img13, title: "From", category: "Terror" },
        { id: 14, image: img14, title: "Oppenheimer", category: "Drama" },
        { id: 15, image: img15, title: "Spider-Man: Cruzando el Multiverso", category: "Animación" },
        { id: 16, image: img16, title: "La Casa de Papel", category: "Acción" },
        { id: 17, image: img17, title: "Shutter Island", category: "Suspense" },
        { id: 18, image: img18, title: "Titanic", category: "Drama" },
        { id: 19, image: img19, title: "Juego de Tronos", category: "Fantasía" },
        { id: 20, image: img20, title: "Respira", category: "Drama Médico" },
        { id: 21, image: img21, title: "Hunter x Hunter", category: "Animación" },
        { id: 22, image: img22, title: "Arcane", category: "Animación" },
        { id: 23, image: img23, title: "Rick y Morty", category: "Animación" },
        { id: 24, image: img24, title: "The Good Doctor", category: "Drama Médico" },
        { id: 25, image: img25, title: "Stranger Things", category: "Ciencia Ficción" },
        { id: 26, image: img26, title: "Vis a Vis", category: "Drama" },
        { id: 27, image: img27, title: "IT: Bienvenidos a Derry", category: "Terror" },
        { id: 28, image: img28, title: "Respira", category: "Drama Médico" }
    ];

    const [currentIndex, setCurrentIndex] = useState(0);
    const [wcIntroOpen, setWcIntroOpen] = useState(false);
    const navigate = useNavigate();

    const nextSlide = useCallback(() => {
        setCurrentIndex((prevIndex) => (prevIndex + 1) % movies.length);
    }, [movies.length]);

    // Auto-rotation toutes les 2 secondes
    useEffect(() => {
        const interval = setInterval(() => {
            nextSlide();
        }, 2000);

        return () => clearInterval(interval);
    }, [nextSlide]);

    const prevSlide = () => {
        setCurrentIndex((prevIndex) => (prevIndex - 1 + movies.length) % movies.length);
    };

    const getVisibleMovies = () => {
        const result = [];
        for (let i = 0; i < 3; i++) {
            const index = (currentIndex + i) % movies.length;
            result.push(movies[index]);
        }
        return result;
    };

    return (
        <main className="relative overflow-hidden bg-[#060B1E]">
            <WcIntroOverlay
                open={wcIntroOpen}
                videoId="AdIFVLkd_dE"
                onSkip={() => {
                    // no-op here; parent handles the navigation on finished
                }}
                onFinished={() => {
                    setWcIntroOpen(false);
                    navigate('/wc');
                }}
            />
            
            <div className='container mx-auto px-3 sm:px-5 pt-12 relative z-10'>
                {/* Main Site Hero Section */}
                <div className="mb-12 text-center">
                    <h1 className="text-4xl md:text-6xl title-home font-bold mb-6 text-white max-w-5xl mx-auto">
                        Descubre lo mejor de la IPTV en España 🇪🇸<br/> <span className="inline-flex items-center align-middle gap-1"><img src={tv} alt="logo" className='w-20 h-auto' /><span className="text-yellow-400 nimo" style={{ 
                            textShadow: `
                                -1px -1px 0 #000,
                                0 -1px 0 #000,
                                1px -1px 0 #000,
                                -1px 0 0 #000,
                                1px 0 0 #000,
                                -1px 1px 0 #000,
                                0 1px 0 #000,
                                1px 1px 0 #000,
                                -2px -2px 0 #fff,
                                0 -2px 0 #fff,
                                2px -2px 0 #fff,
                                -2px 0 0 #fff,
                                2px 0 0 #fff,
                                -2px 2px 0 #fff,
                                0 2px 0 #fff,
                                2px 2px 0 #fff
                            `
                        }}>SOLÁ</span></span>
                    </h1>

                    <p className="text-lg text-gray-300 font-light mb-10 leading-relaxed max-w-3xl mx-auto px-4">
                        Disfruta de tu suscripción IPTV con una excelente calidad de imagen 4K en Smart TV, Android y PC. Accede a más de 79.000 canales, VOD ilimitado y soporte 24/7. Compatible con IPTV Smarters, TiviMate y todos los dispositivos IPTV.
                    </p>

                    <div className="mb-10 flex justify-center items-center">
                        <img src={trustpilot} alt="Trustpilot Rating" className='w-[240px] md:w-[270px]' />
                    </div>

                    <div className="flex items-center justify-center flex-col md:flex-row gap-5 mb-16">
                        <button 
                            onClick={() => document.getElementById('pricing')?.scrollIntoView({ behavior: 'smooth' })}
                            className="bg-yellow-400 text-black px-6 py-3 rounded-full w-full sm:w-auto text-md font-bold cursor-pointer flex items-center justify-center gap-3 transition-all duration-300 hover:bg-yellow-300 hover:scale-105 hover:shadow-2xl shadow-lg">
                            <span>Empezar ahora</span>
                            <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
                                <path d="M5 12h14M12 5l7 7-7 7" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                            </svg>
                        </button>
                    </div>

                    {/* Compact World Cup 2026 Promotional Banner */}
                    <div className="mt-8 mb-20 px-4">
                        <WorldCupBanner 
                            onWatchLive={() => setWcIntroOpen(true)}
                            onViewSchedule={() => document.getElementById('pricing')?.scrollIntoView({ behavior: 'smooth' })}
                        />
                    </div>
                </div>

                {/* Content Carousel Section */}
                <div className=" mt-0 md:mt-16">
                    <div className="flex items-center justify-between mb-8 mt-0 md:mt-16 relative">
                        <h2 className="text-xl md:text-4xl lg:text-5xl font-bold text-white text-center">VOD y Películas Destacadas</h2>
                        <div className="flex gap-2 md:gap-4 absolute right-0">
                            <button 
                                onClick={prevSlide}
                                className="w-10 h-10 md:w-12 md:h-12 rounded-full bg-white/10 backdrop-blur-md border border-white/20 flex items-center justify-center text-white hover:bg-white/20 transition-all duration-300 hover:scale-110"
                            >
                                <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
                                    <path d="M15 18l-6-6 6-6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                                </svg>
                            </button>
                            <button 
                                onClick={nextSlide}
                                className="w-10 h-10 md:w-12 md:h-12 rounded-full bg-white/10 backdrop-blur-md border border-white/20 flex items-center justify-center text-white hover:bg-white/20 transition-all duration-300 hover:scale-110"
                            >
                                <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
                                    <path d="M9 18l6-6-6-6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                                </svg>
                            </button>
                        </div>
                    </div>
                    
                    {/* Carousel Film Container */}
                    <div className="grid grid-cols-1 lg:grid-cols-3 gap-6 overflow-hidden min-h-[320px]">
                        <AnimatePresence mode='popLayout' initial={false}>
                            {getVisibleMovies().map((movie, index) => (
                                <motion.div
                                    layout
                                    key={movie.id}
                                    initial={{ opacity: 0, scale: 0.8, x: 100 }}
                                    animate={{ opacity: 1, scale: 1, x: 0 }}
                                    exit={{ opacity: 0, scale: 0.8, x: -100 }}
                                    transition={{ 
                                        type: "spring",
                                        stiffness: 300,
                                        damping: 30,
                                        opacity: { duration: 0.2 }
                                    }}
                                    className={`relative group cursor-pointer overflow-hidden rounded-2xl h-64 sm:h-80 lg:h-64 ${index > 0 ? 'hidden lg:block' : ''}`}
                                >
                                    <img
                                        src={movie.image} 
                                        alt={movie.title} 
                                        className="absolute top-0 left-0 w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
                                    />
                                    
                                    {/* Category Badge */}
                                    {movie.category && (
                                        <div className="absolute top-4 left-4 z-10">
                                            <div className="bg-white text-black px-3 py-1 rounded-full text-sm font-semibold">
                                                {movie.category}
                                            </div>
                                        </div>
                                    )}
                                    
                                    <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-transparent to-transparent"></div>
                                    
                                    {/* Content */}
                                    <div className="absolute bottom-0 left-0 p-4 text-white w-full">
                                        <h3 className="text-lg font-bold mb-1 transform translate-y-2 group-hover:translate-y-0 transition-transform duration-300">
                                            {movie.title}
                                        </h3>
                                    </div>
                                </motion.div>
                            ))}
                        </AnimatePresence>
                    </div>
                </div>

                {/* Channel Carousel */}
                <div className="mb-20">
                    <ChannelCarousel/>
                </div>

                {/* Features */}
                <div className="mt-20 mb-10">
                    <h2 className="text-4xl md:text-5xl lg:text-6xl font-bold text-white text-center mb-16">
                        Por qué elegir <span className="text-yellow-400">TVSOLA</span> para su IPTV?
                    </h2>
                    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 max-w-7xl mx-auto">
                        {/* Card 1 - 79.000+ Chaînes */}
                        <div className="bg-white/5 backdrop-blur-md rounded-3xl p-8 border border-white/10 hover:bg-white/10 transition-all duration-500 hover:-translate-y-2 hover:shadow-2xl">
                            <div className="flex flex-col md:flex-row gap-5 md:gap-0 items-center mb-6">
                                <div className="w-[72px] h-16 bg-yellow-400 rounded-2xl flex items-center justify-center mr-0 md:mr-6">
                                    <svg xmlns="http://www.w3.org/2000/svg" className="w-8 h-8 text-black" viewBox="0 0 24 24"><g fill="none" fillRule="evenodd"><path d="m12.593 23.258l-.011.002l-.071.035l-.02.004l-.014-.004l-.071-.035q-.016-.005-.024.005l-.004.01l-.017.428l.005.02l.01.013l.104.074l.015.004l.012-.004l.104-.074l.012-.016l.004-.017l-.017-.427q-.004-.016-.017-.018m.265-.113l-.013.002l-.185.093l-.01.01l-.003.011l.018.43l.005.012l.008.007l.201.093q.019.005.029-.008l.004-.014l-.034-.614q-.005-.018-.02-.022m-.715.002a.02.02 0 0 0-.027.006l-.006.014l-.034.614q.001.018.017.024l.015-.002l.201-.093l.01-.008l.004-.011l.017-.43l-.003-.012l-.01-.01z"/><path fill="currentColor" d="M16.95 4.007a1 1 0 0 0-1.414-1.414l-3.89 3.889a.5.5 0 0 1-.707 0L8.464 4.007A1 1 0 0 0 7.05 5.42l1.414 1.414q.086.086.175.165H5a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2h-5.053a4 4 0 0 0 .174-.165zM5 9h14v10H5z"/></g></svg>
                                </div>
                                <h3 className="text-2xl font-bold text-white">79.000+ Canales IPTV</h3>
                            </div>
                            <p className="text-gray-300 leading-relaxed text-lg text-center md:text-left">
                                Una lista completa de todos los canales europeos e internacionales. Con más de 79.000 canales, ofrecemos la mejor lista m3u del mercado para IPTV Smarters y otros reproductores.
                            </p>
                        </div>

                        {/* Card 2 - Connexion ultra-rapide */}
                        <div className="bg-white/5 backdrop-blur-md rounded-3xl p-8 border border-white/10 hover:bg-white/10 transition-all duration-500 hover:-translate-y-2 hover:shadow-2xl">
                            <div className="flex flex-col md:flex-row gap-5 md:gap-0 items-center mb-6">
                                <div className="w-16 h-16 bg-yellow-400 rounded-2xl flex items-center justify-center mr-0 md:mr-6">
                                    <svg className="w-8 h-8 text-black" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 10V3L4 14h7v7l9-11h-7z" />
                                    </svg>
                                </div>
                                <h3 className="text-2xl font-bold text-white">Servidores IPTV Estables</h3>
                            </div>
                            <p className="text-gray-300 leading-relaxed text-lg text-center md:text-left">
                                A diferencia de otros proveedores de IPTV ilegal, TVConnect utiliza servidores dedicados de alto rendimiento. Zapping ultrarrápido en moins d'un demi-seconde et sans cuts lors des matchs.
                            </p>
                        </div>

                        {/* Card 3 - Installation instantanée */}
                        <div className="bg-white/5 backdrop-blur-md rounded-3xl p-8 border border-white/10 hover:bg-white/10 transition-all duration-500 hover:-translate-y-2 hover:shadow-2xl">
                            <div className="flex flex-col md:flex-row gap-5 md:gap-0 items-center mb-6">
                                <div className="w-16 h-16 bg-yellow-400 rounded-2xl flex items-center justify-center mr-0 md:mr-6">
                                    <svg className="w-8 h-8 text-black" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z" />
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                                    </svg>
                                </div>
                                <h3 className="text-2xl font-bold text-white">Instalación Fácil</h3>
                            </div>
                            <p className="text-gray-300 leading-relaxed text-lg text-center md:text-left">
                                Configuración sencilla de su suscripción IPTV en Smart TV, Android Box, Fire Stick o PC. Proporcionamos los códigos Xtream y m3u instantáneamente después de la compra.
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </main>
    )
}